/* eslint-disable no-unused-vars */
import effects from 'app/effects/effects'
import * as R from 'ramda'
import momentTimezone from 'moment-timezone'
import timezoneData from 'libs/timezoneData.json'

const bootstrap = () => {
  momentTimezone.tz.load(timezoneData)

  if (R.has('REACT_APP_DEBUG', process.env)) {
    window.effects = effects
  }
}

const addAllPermissions = R.compose(
  Promise.resolve.bind(Promise),
  // R.set(R.lensPath(['places', 0, 'roles']), mockedRoles),
  R.over(
    R.lensPath(['places', 0, 'roles']),
    R.map(
      R.when(
        R.propEq('type', 2),
        R.mergeLeft({ permissions: { key: ['ALL_PERMISSIONS'] } }),
      ),
    ),
  ),
)

const me = effects.apis.me
effects.apis.me = (input) => me(input).then(addAllPermissions)

const getAdminProfile = effects.apis.getAdminProfile
effects.apis.getAdminProfile = (input) =>
  getAdminProfile(input).then(addAllPermissions)

export default bootstrap
